import React from 'react';
import './footer.css';
import { FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className='footerBack'>
            <div className="footer_container">
                <div className="contacts">
                    <h2 className='footer_contacts_block'>
                        Наши контакты:
                    </h2>
                    <div className="contacts_container">
                        <div className='contacts_text'>
                            Почта для связи: archmiplan@gmail.com
                        </div>
                        <div className='contacts_text'>
                            Телефон: +7 988 206-96-39
                        </div>
                        <div className='contacts_text'>
                            Офис в Махачкале по адресу:  ул. Магомета Гаджиева, 73А
                        </div>
                        <div className='contacts_text'>

                        </div>
                    </div>
                    <div className="contacts_messengers_container">
                        <div className='foter_border_icons'>
                            <a className='telegrammIcon' href="https://t.me/+taYiWcp4vAo4OGIy" target="_blank" rel="noopener noreferrer">
                                <FaTelegramPlane color="#fcfafaff" />
                            </a>
                        </div>
                        <div className='foter_border_icons'>
                            <a className='whatsapIcon' href="https://wa.me/+79882069639" target="_blank" rel="noopener noreferrer">
                                <FaWhatsapp className='whatsapIcon' color="#f7f9f8ff" />
                            </a>
                        </div>
                    </div>
                </div>
                {/* Левая часть - контакты */}
                {/* <div className="contacts">
                    <div className='mail'>
                        Почта для связи: <br></br> archmiplan@gmail.com
                    </div>
                    <div className='phoneNumber'>
                        Номер телефона: <br></br>+7 988 206-96-39
                    </div>
                    <div className='mail'>
                        Наш офис находится в Махачкале по адресу: 
                    </div>
                    <div className='phoneNumber'>
                        ул. Магомета Гаджиева, 73А
                    </div>
                </div>
                
                <div className='messangers'>
                    <a className='telegrammIcon' href="https://t.me/+taYiWcp4vAo4OGIy" target="_blank" rel="noopener noreferrer">
                        <FaTelegramPlane className='telegrammIcon' color="#fcfafaff" />
                    </a>
                    <a className='whatsapIcon' href="https://wa.me/+79882069639" target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp className='whatsapIcon' color="#f7f9f8ff" />
                    </a>
                </div>
                

                <div className='address'>
                    
                </div> */}
            </div>
        </footer>
    )
}

export default Footer